import { ChannelMenu } from "@components/chat/ChannelMenu";
import { Button } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import classNames from "classnames";
import styles from "./styles.module.less";

interface FanPageMenuProps {
  isFanpageMenuOpen: boolean;
  handleToggleFanpageMenu: (e: React.MouseEvent) => void;
}

export const FanPageMenu = ({
  isFanpageMenuOpen,
  handleToggleFanpageMenu,
}: FanPageMenuProps) => {
  return (
    <aside
      className={classNames(styles.left, {
        [styles.collapsed]: !isFanpageMenuOpen,
      })}
    >
      <div className={styles.fanpageTitle}>
        <span
          className={styles.logo}
          onClick={handleToggleFanpageMenu}
          role="button"
        >
          K
        </span>
        {isFanpageMenuOpen && <span>Quản lý Kênh</span>}
      </div>
      <ChannelMenu
        isCollapsed={!isFanpageMenuOpen}
        handleToggleFanpageMenu={handleToggleFanpageMenu}
      />
      <div
        className={styles.toggleButtonWrapper}
      >
        <Button
          type="text"
          icon={
            isFanpageMenuOpen ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />
          }
          className={styles.toggleButton}
          onClick={handleToggleFanpageMenu}
        />
      </div>
    </aside>
  );
};
